export const STATE_META = {
  CALCOLATO: { label: "CALCOLATO", cls: "bg-ok-100 text-ok-800 border-ok-300" },
  PARZIALE: { label: "PARZIALE", cls: "bg-warn-100 text-warn-800 border-warn-300" },
  CAM_OR_OWNER_INPUT_REQUIRED: { label: "CAM_OR_OWNER_INPUT_REQUIRED", cls: "bg-risk-100 text-risk-800 border-risk-300" },
  MANUALE: { label: "MANUALE", cls: "bg-tech-100 text-tech-800 border-tech-300" },
  MANUALE_DA_APPROVARE: { label: "MANUALE_DA_APPROVARE", cls: "bg-warn-100 text-warn-900 border-warn-400" },
  ERROR: { label: "ERROR", cls: "bg-ink text-white border-ink" },
};
export const STATES = Object.keys(STATE_META);

export const mm = (v) => (v == null ? "—" : `${Number(v).toFixed(1)} mm`);
export const sec = (v) => (v == null ? "—" : `${Number(v).toFixed(2)} s`);
export const secMin = (v) => (v == null ? "—" : `${Number(v).toFixed(2)} s (${(Number(v) / 60).toFixed(2)} min)`);
export const eur = (v, d = 2) => (v == null ? "—" : `€ ${Number(v).toFixed(d)}`);
export const num = (v, d = 2) => (v == null ? "—" : Number(v).toFixed(d));

export const speedLabel = (lt) => {
  const paths = lt.length_estimate?.paths;
  if (paths?.length) {
    const external = paths.find(p=>p.key === "external")?.speed_mm_min;
    const internal = paths.find(p=>p.key !== "external" && p.length_mm > 0)?.speed_mm_min;
    return `est. ${num(external, 0)} · int. ${num(internal, 0)} mm/min`;
  }
  const sp = lt.cycle?.speed || lt.pierce_only_cycle?.speed;
  if (sp?.effective_speed_mm_min != null) return `${Number(sp.effective_speed_mm_min).toFixed(0)} mm/min (${Number(sp.speed_mm_s).toFixed(2)} mm/s)`;
  const p = lt.parameter;
  if (p?.nominal_speed_mm_min != null && lt.profile?.efficiency_factor != null) return `${(p.nominal_speed_mm_min * lt.profile.efficiency_factor).toFixed(0)} mm/min`;
  return "—";
};

export const stateOf = (c) => c.laser_time?.row_state || "CAM_OR_OWNER_INPUT_REQUIRED";
